import type { LegalConsents } from "@/api/db/schema/users";
import type { auth as AuthType } from "@/auth/auth";
import { createServerFn } from "@tanstack/react-start";
import { getRequestHeaders } from "@tanstack/react-start/server";

export const auth = createServerFn({ method: "GET" }).handler(async () => {
  try {
    const { auth: betterAuth } = await import("@/auth/auth");
    const headers = getRequestHeaders();
    const session = (await betterAuth.api.getSession({
      headers,
    })) as typeof AuthType.$Infer.Session | null;

    if (!session) {
      return {
        status: 200,
        body: { authenticated: false as const, properties: null },
      };
    }

    let rawConsents = (session.user as any).legalConsents;
    if (typeof rawConsents === "string") {
      try {
        rawConsents = JSON.parse(rawConsents);
      } catch {
        rawConsents = null;
      }
    }
    const legalConsents = (rawConsents as LegalConsents) || null;
    const hasAcceptedLegalConsents = Boolean(
      legalConsents?.kvkk?.accepted &&
        legalConsents?.privacyPolicy?.accepted &&
        legalConsents?.workoutVideoConsent?.accepted,
    );

    return {
      status: 200,
      body: {
        authenticated: true as const,
        properties: {
          userId: session.user.id,
          userName: session.user.userName as string | undefined,
          role: session.user.role as string | undefined,
          image: session.user.image || null,
          legalConsents,
          hasAcceptedLegalConsents,
        },
      },
    };
  } catch (e) {
    const errorMsg = e instanceof Error ? e.message : String(e);
    console.error(`[auth] CAUGHT ERROR: ${errorMsg}`, e);
    return {
      status: 200,
      body: { authenticated: false as const, properties: null },
    };
  }
});
